var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6153 3.07812H3.38451H3.38472C2.48692 3.07812 1.62604 3.43462 0.991373 4.0695C0.356483 4.70417 0 5.56505 0 6.46285V13.5398V13.5396C0 14.4374 0.3565 15.2982 0.991373 15.9329C1.62604 16.5678 2.48692 16.9243 3.38472 16.9243H16.6155H16.6153C17.5131 16.9243 18.374 16.5678 19.0086 15.9329C19.6435 15.2982 20 14.4374 20 13.5396V6.46263V6.46285C20 5.56505 19.6435 4.70417 19.0086 4.0695C18.374 3.43461 17.5131 3.07812 16.6153 3.07812ZM14.0584 10.4105L8.05841 13.4875C7.91546 13.5615 7.74419 13.5557 7.60661 13.472C7.46882 13.3885 7.38468 13.2391 7.38447 13.0782V6.92432C7.38468 6.76335 7.46882 6.61397 7.60661 6.53047C7.74419 6.44677 7.91546 6.44097 8.05841 6.51502L14.0584 9.59194C14.2125 9.67093 14.3095 9.82954 14.3095 10.0027C14.3095 10.176 14.2125 10.3346 14.0584 10.4135V10.4105Z",
    fill: "#192830"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8d6254f74215875439cb0d83d7fe7a5a.svg";
export { ForwardRef as ReactComponent };